import { type AddSnapPixelScript } from './snap-pixel.types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Add the Snap Pixel script to the head of the document.
 *
 * @see {@link https://businesshelp.snapchat.com/s/article/pixel-generate-code?language=en_US}
 */
export const addSnapPixelScript: AddSnapPixelScript = () => {
  if (document.querySelector(`script[id="${SNAP_PIXEL_SCRIPT_ID}"]`)) return;

  const script = document.createElement('script');

  script.id = SNAP_PIXEL_SCRIPT_ID;
  script.append(document.createTextNode(SNAP_PIXEL_SCRIPT));

  document.head.append(script);
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SNAP_PIXEL_SCRIPT_ID = 'snap-pixel-script';

const SNAP_PIXEL_SCRIPT = `(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
{a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
r.src=n;var u=t.getElementsByTagName(s)[0];
u.parentNode.insertBefore(r,u);})(window,document,
'https://sc-static.net/scevent.min.js');`;
